/**
 * @fileoverview Test Automation Leverage API Service
 * @description API calls for the Test Automation Leverage feature
 * @module features/TestAutomationLeverage/services/testAutomationLeverageApi
 */

import { apiClient } from '@/services';

const BASE_PATH = '/v1/test-automation-leverage';

export const testAutomationLeverageApi = {
  /**
   * Health check
   * @returns {Promise<object>}
   */
  health: () => apiClient.get(`${BASE_PATH}/health`),

  /**
   * Fetch auto-generated test cases
   * @param {number} [days=30] - Look-back window in days
   * @returns {Promise<object>} { testCases, count, days }
   */
  fetchTestCases: (days = 30) =>
    apiClient.get(`${BASE_PATH}/test-cases`, { days }),

  /**
   * Fetch aggregated summary by project
   * @param {number} [days=30] - Look-back window in days
   * @returns {Promise<object>} { totalCount, days, byProject, byState }
   */
  fetchSummary: (days = 30) =>
    apiClient.get(`${BASE_PATH}/summary`, { days }),

  /**
   * Fetch monthly metrics with savings calculations
   * @param {object} params
   * @param {number} [params.days=90]
   * @param {number} [params.hoursPerTest]
   * @param {number} [params.hourlyRate]
   * @returns {Promise<object>}
   */
  fetchMonthlyMetrics: ({ days = 90, hoursPerTest, hourlyRate } = {}) => {
    const params = { days };
    if (hoursPerTest != null) params.hoursPerTest = hoursPerTest;
    if (hourlyRate != null) params.hourlyRate = hourlyRate;
    return apiClient.get(`${BASE_PATH}/monthly-metrics`, params);
  },
};
